"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  LABEL: {
    TYPE: 'default',
    DISPLAY: 'inlineFlex'
  },
  SUB_LABEL: {
    COLOR: 'greyDarker',
    type: 'small',
    DISPLAY: 'inlineFlex'
  },
  BORDER_COLOR: 'greyMedium',
  BORDER_OPACITY: '0.3',
  REMOVE_BUTTON: {
    COLOR: 'secondary',
    TYPE: 'sub'
  }
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;